import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { RootState } from '@next/core-lib/app';
import { AgrNumberDirective } from '@next/core-lib/form';
import { TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { skipWhile, take } from 'rxjs/operators';

import { AnimalGroup } from '../../models/animal-group.model';
import * as animalGroupActions from '../../store/animal-group.actions';
import { getSelectedAnimalGroup } from '../../store/animal-group.selectors';

@Component({
  selector: 'app-observations',
  templateUrl: './observations.component.html',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    AgrNumberDirective,
    MatButton,
    TranslatePipe,
  ],
})
export class ObservationsComponent implements OnInit {
  animalGroup$: Observable<AnimalGroup> = this.store.select(getSelectedAnimalGroup);

  form: FormGroup = new FormGroup({
    startWeight: new FormControl(''),
    realizedGrowth: new FormControl(''),
    realizedFeedintake: new FormControl(''),
    realizedFeedconversion: new FormControl({ value: '', disabled: true }),
  });

  constructor(private readonly store: Store<RootState>) {}

  ngOnInit(): void {
    const calculateFeedconversion = (feedintake: number, growth: number) => {
      let feedconversion = Number(Math.round((feedintake / growth) * 100) / 100);
      if (feedconversion === Infinity || isNaN(feedconversion)) {
        feedconversion = 0;
      }
      this.form.controls.realizedFeedconversion.setValue(feedconversion);
    };
    this.form.controls.realizedGrowth.valueChanges.subscribe((growth: number) =>
      calculateFeedconversion(Number(this.form.controls.realizedFeedintake.value), growth),
    );
    this.form.controls.realizedFeedintake.valueChanges.subscribe((feedintake: number) =>
      calculateFeedconversion(feedintake, Number(this.form.controls.realizedGrowth.value)),
    );
    this.animalGroup$
      .pipe(
        skipWhile((animalGroup: AnimalGroup) => animalGroup === undefined),
        take(1),
      )
      .subscribe((animalGroup: AnimalGroup) => {
        this.form.controls.startWeight.setValue(animalGroup.observation.startWeight);
        this.form.controls.realizedGrowth.setValue(animalGroup.observation.realizedGrowthGPerDay);
        this.form.controls.realizedFeedintake.setValue(
          animalGroup.observation.realizedFeedIntakeGPerDay,
        );
        this.form.controls.realizedFeedconversion.setValue(
          animalGroup.observation.realizedFeedConversionRate,
        );
      });
  }

  save() {
    if (this.form.valid) {
      this.animalGroup$.pipe(take(1)).subscribe((animalGroup) => {
        this.store.dispatch(
          animalGroupActions.upsertAnimalGroupGeneral({
            animalGroup: {
              ...animalGroup,
              observation: {
                startWeight: this.form.controls.startWeight.value,
                realizedGrowthGPerDay: this.form.controls.realizedGrowth.value,
                realizedFeedIntakeGPerDay: this.form.controls.realizedFeedintake.value,
                realizedFeedConversionRate: this.form.controls.realizedFeedconversion.value,
              },
            } as AnimalGroup,
          }),
        );
      });
    }
  }
}
